/** Get an array of x ticks based on the x domain or the number of ticks */
export function getXTicks(
  xDomain: unknown[],
  xTicks: number,
  customXTicks?: unknown[]
): unknown[] {
  let xTicksArr: unknown[] = [];

  if (customXTicks) {
    xTicksArr = customXTicks;
  } else {
    // Generate ticks based on the number of ticks specified
    const ticksCount = Math.min(xTicks, xDomain.length); // Ensure not more ticks than available data points
    const step = Math.max(1, Math.floor(xDomain.length / ticksCount)); // Ensure step is at least 1

    for (let i = 0; i < xDomain.length; i += step) {
      xTicksArr.push(xDomain[i]);
    }
  }

  return xTicksArr;
}

// Function to get the x position of a bar
export function getBarX(
  d: Record<string, unknown>,
  xScale: any,
  barWidth: number,
  xValKey: string
) {
  return xScale(d[xValKey]) + (xScale.bandwidth() - barWidth) / 2;
}
